export const primaryColor = '#212121';
export const secondaryColor = '#778899';
export const accentColor = '#ff0808';
export const heartColor = '#ff0808';
export const bgColor = '#f2f5f8';
export const borderColor = '#e7eaed';
export const boxShadow =
  '1px 4px 6px rgba(0, 0, 0, 0.16), 0px 4px 4px rgba(0, 0, 0, 0.06), 0px 1px 1px rgba(0, 0, 0, 0.12)';
export const timingFn = 'cubic-bezier(0.4, 0, 0.2, 1)';
